import { OyResponse } from '@oy/types';
import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import type {
  AssignTxCategoryPayload,
  GetProductCategoryPayload,
  GetTxCategoriesParams,
  ProductCategory,
  TransactionCategory,
  UpdateTxCategoryPayload,
} from 'src/models';
import type { AddCategoryPayload } from 'src/pages/Settings/TransactionCategory/formSchema';

export const getTransactionCategories = (params: GetTxCategoriesParams) => {
  return axios.request<OyResponse<TransactionCategory[]>>({
    method: 'GET',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category`,
    params,
  });
};

export const postCreateTransactionCategory = (data: AddCategoryPayload) => {
  return axios.request<OyResponse<unknown>>({
    method: 'POST',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category/create`,
    data,
  });
};

export const putUpdateTransactionCategory = (data: UpdateTxCategoryPayload) => {
  return axios.request<OyResponse<unknown>>({
    method: 'PUT',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category`,
    data,
  });
};

export const deleteTransactionCategory = (id: string) => {
  return axios.request<OyResponse<unknown>>({
    method: 'DELETE',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category`,
    params: { id },
  });
};

export const postAssignTransactionCategory = (
  data: AssignTxCategoryPayload,
) => {
  return axios.request<OyResponse<unknown>>({
    method: 'POST',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category/assign`,
    data,
  });
};

export const getProductCategories = (data: GetProductCategoryPayload) => {
  return axios.request<OyResponse<ProductCategory[]>>({
    method: 'POST',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category/search-assigned`,
    data,
  });
};

export const postCheckTxCategory = () => {
  return axios.request({
    method: 'POST',
    url: `${BUSINESS_PAYMENT_PREFIX}/tx-category/check-category`,
  });
};
